// Chip del estado de una exportacion. Tres tonos, como en la app original:
// entregada (verde), en curso (dorado) y terminada por otra razon (gris).
export function EstadoExportacion({estado, etiqueta, final}: {estado: string; etiqueta: string; final: boolean}) {
  const clase =
    estado === 'delivered' || estado === 'exported'
      ? 'bg-verde-claro text-verde-oscuro'
      : final
        ? 'bg-papel text-apagado'
        : 'bg-dorado-claro text-tinta';
  return <span className={`rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap ${clase}`}>{etiqueta}</span>;
}
